export default __webpack_public_path__ + "imgs/b986e5f7e5d2863ed07030a33aa4cce6.png";